import { DataBean } from "../DataBean";

export class ImpTransportDestination extends DataBean {




    public async importTransportDestination(filename: any, directory: any, dataStore: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importTransportDestination_String_String_String", [filename, directory, dataStore]);
    }

}